import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {
    Box,
    Grid2 as Grid,
    DialogTitle,
    ButtonGroup,
    FormLabel,
    CircularProgress,
    Chip,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';


import { makeid, myTimestampToDate } from '../utils/ui_utils';
import { add_Cow, edit_Cow, get_Cow_byID } from '../FirebaseUtils/dbCow';
import { differenceInCalendarMonths, format } from 'date-fns';
import { common_data_entry, advance_data_entry, other_data_entry, lifetime_data_entry, mother_data_entry } from '../definitions/cow';
import { PresenceChip } from '../components/PresenceButton';
import { CowtypeChip } from '../components/CowtypeButton';
import { globalstyles } from '../lib/definitions';
import { useEvent } from '../context/eventContext';
import { Close } from '@mui/icons-material';
import { CategoryButton } from '../definitions/category';
import { PropertyButton } from '../definitions/property';
import { CowmanButton } from '../definitions/cowman';


const newcow = {
    name: '',
    cow_type: 'black',
    birth: 0,
}




export const PublicCowDialog = forwardRef(({ }, ref) => {
    const { selEvent } = useEvent()
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newcow })
    const [isLoading, setIsLoading] = useState(false)
    const [showAdvance, setShowAdvance] = useState(false)


    const mapdata_param_key_list = [...common_data_entry, ...advance_data_entry, ...other_data_entry, ...lifetime_data_entry, ...mother_data_entry, ...[{ id: 'id' }]].map((x) => (x.id))




    useImperativeHandle(ref, () => {
        return {
            onShow(el, i, is_c) {
                setIsLoading(true)
                console.log("IS CURRENT", is_c)
                getRealCow(el.id)
                setOpen(true);
            }
        }
    })

    const getRealCow = async (c_id) => {
        const r_c = await get_Cow_byID(selEvent.id, c_id)
        if (r_c) {
            setCurElement(r_c)
            setIsLoading(false)
        } else {

        }

    }

    const handleClose = () => {
        setOpen(false);
    };


    const checkConditional = (param) => {
        if (param.conditional) {
            if (curElement[param.conditional.param] && curElement[param.conditional.param] >= param.conditional.min_value) {
                return true
            }
            return false
        } else {
            return true
        }
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth={true}>
                <DialogTitle>
                    <i>Dati Soggetto:</i> <Chip label={curElement.catalog_id} /> <b>{curElement.name}</b>
                    <ButtonGroup size="small">
                        {showAdvance ?
                            <Button color="secondary" variant={!showAdvance ? 'contained' : 'outlined'} onClick={() => setShowAdvance(false)}>passa a visualizzazione compatta</Button>
                            :
                            <Button color="secondary" variant={showAdvance ? 'contained' : 'outlined'} onClick={() => setShowAdvance(true)}>passa a visualizzazione estesa</Button>
                        }
                    </ButtonGroup>
                </DialogTitle>
                <DialogContent>
                    {isLoading ?
                        <CircularProgress />
                        :
                        <Box>
                            <Box sx={{ width: '100%' }}>
                                <Grid container sx={globalstyles.list_row}>
                                    <Box sx={globalstyles.input_label}>
                                        Presenza alla mostra
                                    </Box>
                                    <PresenceChip is_present={curElement.is_present} showclean />
                                </Grid>
                                <Grid container sx={globalstyles.list_row}>
                                    <Box sx={globalstyles.input_label}>
                                        Tipo di Soggetto
                                    </Box>
                                    <CowtypeChip cow_type={curElement.cow_type} />
                                </Grid>
                                <Grid container sx={globalstyles.list_row}>
                                    <MyInputRead
                                        id={'catalog_id'}
                                        label={'numero catalogo'}
                                        value={curElement.catalog_id || ''}
                                    />
                                </Grid>
                                {curElement.category &&
                                    <Grid container sx={globalstyles.list_row}>
                                        <Box sx={globalstyles.input_label}>
                                            Categoria
                                        </Box>
                                        <CategoryButton element={curElement.category} />
                                    </Grid>
                                }
                                {curElement.property &&
                                    <Grid container sx={globalstyles.list_row}>
                                        <Box sx={globalstyles.input_label}>
                                            Proprietà
                                        </Box>
                                        <PropertyButton element={curElement.property} />
                                    </Grid>
                                }
                                {curElement.cowman &&
                                    <Grid container sx={globalstyles.list_row}>
                                        <Box sx={globalstyles.input_label}>
                                            Allevatore
                                        </Box>
                                        <CowmanButton element={curElement.cowman} />
                                    </Grid>
                                }
                                {common_data_entry.map((p, pk) => {
                                    if (checkConditional(p))

                                        return (
                                            <Grid sx={globalstyles.list_row} key={pk}>

                                                <MyInputRead
                                                    key={pk}
                                                    id={p.id}
                                                    label={p.label}
                                                    type={p.type}
                                                    value={curElement ? curElement[p.id] : ''}
                                                />
                                            </Grid>
                                        )
                                }
                                )}

                            </Box>
                            {selEvent.custom_cow_filter_param_list?.map((cp, kcp) => (
                                <Grid container sx={globalstyles.list_row} key={kcp}>
                                    <Box sx={globalstyles.input_label}>
                                        {cp.param_name}</Box>
                                    {curElement[cp.param_name] ? "si": "no"}
                                </Grid>
                            ))}
                            <Box sx={{ width: '100%', mt: 1 }}>
                                {showAdvance &&
                                    <>
                                        {advance_data_entry.filter(p => {
                                            if (curElement && curElement[p.id]) {
                                                return true
                                            } else {
                                                return false
                                            }

                                        }

                                        ).map((p, pk) => (
                                            <Grid sx={globalstyles.list_row} key={pk}>
                                                <MyInputRead
                                                    key={pk}
                                                    id={p.id}
                                                    label={p.label}
                                                    type={p.type}
                                                    min_value={p.min_value}
                                                    value={curElement ? curElement[p.id] : ''}
                                                />
                                            </Grid>
                                        ))}
                                    </>}
                            </Box>
                        </Box>}
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose} startIcon={<Close />}>Chiudi</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
})


const margin_top = 0.8



const MyInputRead = ({ type, label, id, value, onChange, min_value, btn }) => {
    try {
        if (type === 'date') {
            const v = myTimestampToDate(value)
            const diff = value ? differenceInCalendarMonths(new Date(), v) + ' mesi' : ''
            return (
                <Grid container sx={{ alignItems: 'center', mt: margin_top }}>
                    <Grid size="6" sx={globalstyles.input_label}>
                        {label}
                    </Grid>
                    <Grid size="auto" sx={{ mr: 2 }}>
                        {format(v, 'dd/MM/yyyy')}
                    </Grid>
                    <Grid size="auto" sx={globalstyles.input_label}>
                        Età
                    </Grid>
                    <Grid size={"auto"} sx={{ ml: 1 }}>
                        {diff}
                    </Grid>
                </Grid>
            )
        } else {
            return (

                <Grid container sx={{ alignItems: 'center', mt: margin_top }}>
                    <Grid size="6" sx={globalstyles.input_label}>
                        {label}
                    </Grid>
                    <Grid size="auto">
                        {value}
                    </Grid>
                </Grid>
            )
        }

    } catch (err) {
        return (<></>)

    }
}

